/**
 * Registration Service - регистрация новых пользователей
 */

import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export const registrationService = {
    /**
     * Получить вопросы для регистрации
     */
    getQuestions: async () => {
        return apiClient.postPublic(ENDPOINTS.REGISTER.QUESTIONS, {});
    },

    /**
     * Отправить ответ на вопрос
     */
    submitAnswer: async (questionId, answerId) => {
        return apiClient.postPublic(ENDPOINTS.REGISTER.SUBMIT, {
            question_id: questionId,
            answer: answerId,
        });
    },

    /**
     * Создать аккаунт
     */
    createAccount: async (userData) => {
        return apiClient.put(
            ENDPOINTS.REGISTER.CREATE_ACCOUNT,
            userData,
            false,
            false,
        );
    },

    /**
     * Отправить код подтверждения на email
     */
    sendVerifyCode: async (email) => {
        return apiClient.postPublic(ENDPOINTS.REGISTER.SEND_VERIFY_CODE, {
            email,
        });
    },

    /**
     * Подтвердить код
     */
    submitVerifyCode: async (email, code) => {
        return apiClient.postPublic(ENDPOINTS.REGISTER.SUBMIT_VERIFY_CODE, {
            email,
            code,
        });
    },
};

export default registrationService;
